/**
 * Starter templates — valid (or nearly-valid) drafts an author can begin from.
 * Each returns a fresh draft object (same shape as emptyDraft()).
 */
import { emptyDraft } from "./ruleModel";

const today = () => new Date().toISOString().slice(0, 10);

export const TEMPLATES = [
  {
    id: "first_scan_welcome",
    title: "First-scan welcome bonus",
    blurb: "Give a one-time bonus on a user's very first scan.",
    build: () => ({
      ...emptyDraft(),
      name: "First-scan welcome bonus",
      description: "One-time welcome bonus on the first scan",
      event_type: "scan",
      reward_mode: "one_time",
      valid_from: today(),
      condition: {
        type: "historical_aggregate",
        tracking_key: "any_scan",
        tracking_value: "any_scan",
        aggregate_type: "count",
        operator: "first_N_scans",
        value: 1,
        source_type_filter: ["base_scan"],
      },
      actions: [{ type: "CREDIT", amount: 100, wallet_type: "default", description: "Welcome bonus" }],
    }),
  },
  {
    id: "state_credit",
    title: "State-based points",
    blurb: "Fixed points when a user from a chosen state scans. Pick the state after loading.",
    build: () => ({
      ...emptyDraft(),
      name: "State bonus",
      description: "Fixed bonus for a specific state",
      event_type: "scan",
      reward_mode: "repeating",
      valid_from: today(),
      condition: { type: "fact_check", key: "user_state", operator: "eq", value: "" },
      actions: [{ type: "CREDIT", amount: 20, wallet_type: "default", description: "State bonus" }],
    }),
  },
  {
    id: "mrp_percent",
    title: "% of product MRP",
    blurb: "Reward a percentage of the scanned product's MRP (price).",
    build: () => ({
      ...emptyDraft(),
      name: "MRP % reward",
      description: "Percentage of product MRP as points",
      event_type: "scan",
      reward_mode: "repeating",
      valid_from: today(),
      condition: { type: "fact_check", key: "price", operator: "gt", value: 0 },
      actions: [{ type: "CREDIT_DYNAMIC", base_field: "price", multiplier: 0.05, wallet_type: "default", description: "5% of MRP" }],
    }),
  },
];
